import React from 'react';
import { Box, Typography, Paper, Stack, Divider } from '@mui/material';
import { useCampaignForm } from 'hooks/useCampaignForm';
import { CampaignStepper } from 'components/CampaignStepper';
import { CampaignStepperControls } from '../CampaignStepper/CampaignStepperControls';
import { getStepContent } from './getStepContent';

export const CampaignForm = () => {
  const { stepsData, activeStep, onSubmit } = useCampaignForm();
  const { title, subtitle } = stepsData[activeStep];
  const content = getStepContent(activeStep);

  return (
    <Paper sx={{ p: 5, pb: 6 }} component="form">
      <Box sx={{ mb: 5 }}>
        <Typography variant="h1" sx={{ textAlign: { xs: 'left', sm: 'center' } }} mb={4}>
          {title}
        </Typography>
        <Typography variant="subtitle1" sx={{ textAlign: { xs: 'left', sm: 'center' } }} gutterBottom>
          {subtitle}
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: { xs: 'none', sm: 'block' } }}>
        <CampaignStepper />
      </Box>
      <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
      <Stack pt={10}>{content}</Stack>
      <Divider sx={{ mt: { xs: 6, sm: 10 }, mb: { xs: 6, sm: 10 } }} />
      <CampaignStepperControls onSubmit={onSubmit} />
    </Paper>
  );
};
